import { LayerItem } from "../../services/types";
import { formatDate, formatValueBase } from "../../utils/helpers";

interface ItemCardProps {
    width: string;
    layerItem: LayerItem;
    layerId: number | null;
    isActive: boolean;
    setActiveCardId: (id: number) => void;
};

const ItemCard = ({ width, layerItem, isActive, setActiveCardId, layerId }: ItemCardProps) => {
    // Destructure metric properties
    const { description, name, value, category, activity_date, attributes, id, latitude, longitude } = layerItem;

    // Extract image_url from attributes
    const imageUrl = attributes.find((attr: any) => attr.name === "image_url")?.value;

    // Format activity date
    const formattedDate = formatDate(activity_date);

    const portOrigin = '*';

    // Handle click event for sending point data
    const handleClick = () => {
        setActiveCardId(id); // Update the last active card

        // Send message to the parent window
        window.parent.postMessage(
            {
                message: "showProgramPoint",
                data: {
                    id,
                    latitude,
                    longitude,
                    name,
                    layerId
                },
            },
            portOrigin
        );
        console.log("Program point message sent:", { id, latitude, longitude });
    };

    return (
        <div
            className={`bg-white border border-[#E4E4E4] p-4 rounded-md shadow-md ${width} flex flex-row items-start gap-4 hover:cursor-pointer transition-all duration-150 
            ${isActive ? 'border-4 border-port-green shadow-lg' : ''} 
            hover:shadow-lg hover:border-2 hover:border-port-green`}
            onClick={handleClick}
        >
            {/* Image on the left */}
            {imageUrl && (
                <img
                    src={imageUrl}
                    alt={`${name} Image`}
                    className="w-36 max-h-32 object-cover"
                />
            )}

            {/* Content on the right */}
            <div className="flex flex-col justify-between overflow-hidden">
                {/* Name */}
                <h2 className="text-sm font-bold text-port-blue mb-2 border-b">{name}</h2>
                {/* Category */}
                <p className="text-[9px] text-port-blue mb-2">{category?.toUpperCase()}</p>
                {/* Description with HTML */}
                <div
                    className="text-[11px] text-port-text mb-4"
                    dangerouslySetInnerHTML={{ __html: description }}
                />

                {/* Fund Amount */}
                <p className="text-[11px] text-port-text">
                    <strong>Fund Amount:</strong> {formatValueBase(value, 'currency')}
                </p>

                {/* Footer with Activity Date */}
                <div className="flex items-center justify-between mt-2 text-[9px] text-port-text">
                    
                    <span>{formattedDate}</span>
                </div>
            </div>
        </div>
    );
};

export default ItemCard;
